import { makeStyles } from '@rbx/ui';
import {
  engineRevampMonospaceTextStyle,
  getEngineRevampInlineCodeTagStyle,
} from '@modules/ui/shared/utils/styles';

const useEnumItemsTableStyles = makeStyles()((theme) => ({
  container: {
    marginTop: '24px',
    marginBottom: '24px',
  },
  table: {
    border: '1px solid',
    borderColor: theme.palette.components.divider,
    borderRadius: '4px',
    borderCollapse: 'separate',
    borderSpacing: 0,
    overflow: 'hidden',
  },
  headerCell: {
    padding: '12px 16px',
    borderBottom: `1px solid ${theme.palette.components.divider}`,
  },
  headerText: {
    fontWeight: 600,
  },
  nameText: {
    ...getEngineRevampInlineCodeTagStyle(theme),
  },
  valueText: {
    ...engineRevampMonospaceTextStyle,
  },
  tableRow: {
    '& td': {
      padding: '12px 16px',
      borderBottom: `1px solid ${theme.palette.components.divider}`,
    },
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  deprecatedText: {
    color: `${theme.palette.content.disabled} !important`,
    '& *': {
      color: `${theme.palette.content.disabled} !important`,
    },
  },
}));

export default useEnumItemsTableStyles;
